module.exports = __webpack_public_path__ + "res/ic_arrow_z_a_m.5f3603bfb31cf8a1dda89b4d7c7c05f0.png";